import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  FormLabel,
  HStack,
  Icon,
  Input,
  Stack,
  Text,
  Tooltip,
  VStack,
} from "@chakra-ui/react";
import { MdInfoOutline } from "react-icons/md";
import MainInput from "../../../../components/Form/input";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { openQuestionsListModel } from "../../../../modules/admin-modules/models/Actions";

const LabelWithHint = ({ children, hint }) => (
  <HStack spacing="6px" mb="2" alignItems="center">
    <FormLabel mb="0">{children}</FormLabel>
    {hint && (
      <Tooltip
        label={hint}
        hasArrow
        placement="top"
        bg="gray.700"
        color="white"
        borderRadius="8px"
        px="3"
        py="2"
        fontSize="sm"
        maxW="280px"
        textAlign="right"
      >
        <Box as="span" display="inline-flex" cursor="help" color="gray.500">
          <Icon as={MdInfoOutline} boxSize="18px" />
        </Box>
      </Tooltip>
    )}
  </HStack>
);

const SettingCard = ({ title, children }) => (
  <Box
    w="100%"
    bg="#fafafa"
    border="1px solid"
    borderColor="gray.200"
    borderRadius="16px"
    p="20px"
  >
    {title && (
      <Text fontWeight="600" color="main_1" mb="16px" fontSize="16px">
        {title}
      </Text>
    )}
    {children}
  </Box>
);

const StepTwo = ({
  watchTotalQustions,
  watchSubType,
  watchQuestionWay,
  data,
  setValue,
  register,
  errors,
  isFormOne,
  watchChapters,
  isAdd,
  watchType,
}) => {
  const dispatch = useDispatch();
  const colourStyles = {
    control: (styles) => ({
      ...styles,
      width: "100%",
      background: "#f5f5f5",
      color: "#690000",
      borderRadius: "16px",
    }),
    option: (styles) => ({ ...styles, color: "#690000" }),
  };

  const [fieldsCount, setFieldsCount] = useState(1);

  const chapters = useSelector((state) => state.chapters.chapters);
  const groups = useSelector((state) => state.groups.groups);
  const performanceGroups = useSelector(
    (state) => state.groups.performanceGroups
  );

  const groupsOptions = groups?.map((data) => {
    return { value: data.id, label: data.name };
  });

  const performanceGroupsOptions =
    performanceGroups?.length > 0
      ? performanceGroups?.map((data) => {
          return { value: data.id, label: data.name };
        })
      : [];

  const activeChaptersOptions = chapters
    ?.filter((data) => Number(data.active) === 1)
    ?.map((data) => {
      return { value: data.id, label: data.name };
    });
  const inactiveChaptersOptions = chapters
    ?.filter((data) => Number(data.active) === 0)
    ?.map((data) => {
      return { value: data.id, label: data.name };
    });

  useEffect(() => {
    setValue("sub_type", 2);
    setValue("chapters[1][no_of_questions]", 0);
    setValue(
      "essay_type",
      !isAdd && data?.essay_type != null && data?.essay_type !== ""
        ? String(data.essay_type)
        : ""
    );
    if (!isAdd && data?.chapters?.length) {
      setFieldsCount(Math.max(1, data.chapters.length - 1));
      data.chapters.forEach((ch, idx) => {
        if (idx === 0) return;
        setValue(
          `chapters[${idx + 1}][type]`,
          String(ch?.type ?? 0)
        );
      });
    } else {
      setFieldsCount(1);
      setValue("chapters[2][type]", "0");
    }
  }, [isAdd, data, setValue]);

  const totalSelectedQuestions = watchChapters?.reduce((accumulator, value) => {
    return Number(accumulator) + Number(value?.no_of_questions || 0);
  }, 0);

  return (
    <VStack
      display={!isFormOne ? "flex" : "none"}
      dir="rtl"
      w="100%"
      flexWrap="wrap"
      justifyContent="space-between"
      spacing="24px"
      mt="24px"
    >
      <SettingCard title="المجموعات">
        <HStack w="100%" gap={5} alignItems="flex-start" flexWrap="wrap">
          <Box w={{ base: "100%", md: "45%" }}>
            <LabelWithHint hint="اختر المجموعات التي سيظهر لها هذا الاختبار">
              المجموعات :
            </LabelWithHint>
            <Select
              options={groupsOptions}
              isMulti={true}
              onChange={(data) => {
                const selectedGroups = data.map((val) => val.value);
                setValue("groups", selectedGroups);
              }}
              styles={colourStyles}
              placeholder="المجموعات"
              defaultValue={data?.groups?.map((val) => {
                return { label: val?.name, value: val?.id };
              })}
            />
          </Box>
          <Box w={{ base: "100%", md: "45%" }}>
            {performanceGroupsOptions?.map((data, index) => {
              return (
                <Box key={data?.value || index} mb="12px">
                  <FormLabel>{data?.label}</FormLabel>
                  <MainInput
                    label=""
                    defaultValues={data.question_number}
                    error={errors?.question_number?.message}
                    placeholder=" ادخل عدد الدرجات "
                    register={register}
                    name="question_number"
                    required={false}
                    onChange={(e) => {
                      setValue(
                        `chapters[${index + 1}][min_target]`,
                        e?.target?.value
                      );
                      setValue(
                        `chapters[${index + 1}][performance_gp_id]`,
                        data?.id
                      );
                    }}
                  />
                </Box>
              );
            })}
          </Box>
        </HStack>
      </SettingCard>

      <SettingCard title="طريقة وعدد الأسئلة">
        <Box mb="20px">
          <LabelWithHint hint="اختر إن كانت الأسئلة يدوية من المدرس أو عشوائية من بنك الأسئلة">
            طريقة السؤال :
          </LabelWithHint>
          <Stack direction="row" spacing="30px" flexWrap="wrap">
            <label>
              <input
                {...register("random", { required: "هذه المعلومات مطلوبة" })}
                type="radio"
                value="0"
                defaultChecked={data?.random == 0 ? true : false}
              />
              {" "}أسئلة يختارها المدرس
            </label>
            <label>
              <input
                {...register("random", { required: "هذه المعلومات مطلوبة" })}
                type="radio"
                value="1"
                defaultChecked={data?.random == 1 ? true : false}
              />
              {" "}اسئلة عشوائية من بنك الاسئلة
            </label>
            <Text color="red">{errors?.random?.message}</Text>
          </Stack>
        </Box>

        <Box mb="20px">
          <LabelWithHint hint="هل الأسئلة ستكون من الأسئلة التي تم وضع بوك مارك عليها أم من جميع الأسئلة؟">
     
            مصدر الأسئلة :
          </LabelWithHint>
          <Stack direction="row" spacing="30px" flexWrap="wrap">
            <label>
              <input
                {...register("book_mark", {
                  required: "هذه المعلومات مطلوبة",
                })}
                type="radio"
                value="0"
                defaultChecked={
                  isAdd ? true : data?.book_mark == 0 ? true : false
                }
              />
              {" "}من كل الاسئلة
            </label>
            <label>
              <input
                {...register("book_mark", {
                  required: "هذه المعلومات مطلوبة",
                })}
                type="radio"
                value="1"
                defaultChecked={data?.book_mark == 1 ? true : false}
              />
              {" "}من البوك مارك
            </label>
            <Text color="red">{errors?.book_mark?.message}</Text>
          </Stack>
        </Box>

        <HStack w="100%" alignItems="flex-end" flexWrap="wrap" gap="16px">
          <Box w={{ base: "100%", md: "50%" }}>
            <LabelWithHint hint="العدد الإجمالي لأسئلة هذا الاختبار">
              عدد الأسئلة :
            </LabelWithHint>
            <MainInput
              label=""
              defaultValues={data.question_number}
              error={errors?.question_number?.message}
              placeholder=" ادخل عدد الأسئلة "
              register={register}
              name="question_number"
              required={false}
            />
          </Box>
          {!isAdd && watchQuestionWay == 0 && (
            <Button onClick={() => dispatch(openQuestionsListModel())}>
              أخترالاسئلة
            </Button>
          )}
        </HStack>
      </SettingCard>

      <SettingCard title="الأسئلة المقالية">
        <Box>
          <LabelWithHint hint="اختياري. إذا احتوى الاختبار على أسئلة مقالية، حدد كيف سيجيب الطالب عليها. يمكن تركه فارغاً">
            طريقة إجابة الأسئلة المقالية :
          </LabelWithHint>
          <Stack direction="row" spacing="30px" flexWrap="wrap">
            <label>
              <input
                {...register("essay_type")}
                type="radio"
                value=""
                defaultChecked={
                  isAdd || data?.essay_type == null || data?.essay_type === ""
                }
              />
              {" "}الامتحان ليس به اسئلة مقالية
            </label>
            <label>
              <input
                {...register("essay_type")}
                type="radio"
                value="0"
                defaultChecked={
                  !isAdd &&
                  data?.essay_type != null &&
                  String(data?.essay_type) === "0"
                }
              />
              {" "}إجابة نصية
            </label>
            <label>
              <input
                {...register("essay_type")}
                type="radio"
                value="1"
                defaultChecked={!isAdd && String(data?.essay_type) === "1"}
              />
              {" "}رفع ملف PDF
            </label>
          </Stack>
        </Box>
      </SettingCard>

      {watchTotalQustions && (
        <SettingCard title="مصدر الأسئلة ومكان الظهور">
          <Box
            mb="16px"
            p="12px"
            bg="blue.50"
            borderRadius="12px"
            border="1px solid"
            borderColor="blue.100"
          >
            <Text fontSize="14px" color="gray.700" lineHeight="1.8">
              <Text as="span" fontWeight="600" color="main_1">
                الفصل
              </Text>{" "}
              يحدد أين سيظهر الامتحان للطالب، بينما{" "}
              <Text as="span" fontWeight="600" color="main_1">
                حافظة الاسئلة
              </Text>{" "}
              تحدد من أين تُسحب أسئلة الامتحان.
            </Text>
          </Box>

          <Box mb="20px" maxW={{ base: "100%", md: "50%" }}>
            <LabelWithHint hint="الفصل الذي سيظهر فيه الامتحان للطالب داخل المنهج">
              الفصل (أين سيظهر الامتحان) :
            </LabelWithHint>
            <Select
              options={activeChaptersOptions}
              isMulti={false}
              onChange={(selected) => {
                setValue("chapters[1][chapter_id]", selected?.value);
                setValue("chapters[1][no_of_questions]", 0);
              }}
              styles={colourStyles}
              placeholder="اختر الفصل (مكان ظهور الامتحان)"
              defaultValue={
                data?.chapters?.[0]
                  ? {
                      label: data?.chapters?.[0]?.name,
                      value: data?.chapters?.[0]?.id,
                    }
                  : null
              }
            />
          </Box>

          <VStack w="100%" alignItems="stretch" spacing="16px">
            <LabelWithHint hint="حافظة الاسئلة التي سيتم سحب أسئلة الامتحان منها">
              حافظة الاسئلة (أسئلة الامتحان منين) :
            </LabelWithHint>

            {[...Array(fieldsCount)].map((val, index) => {
              return (
                <HStack
                  w="100%"
                  spacing="20px"
                  key={index}
                  alignItems="flex-end"
                  flexWrap="wrap"
                  p="14px"
                  bg="white"
                  borderRadius="12px"
                  border="1px solid"
                  borderColor="gray.200"
                >
                  <Box flex="1" minW="220px">
                    <FormLabel fontSize="14px" color="gray.600">
                      الحافظة {index + 1}
                    </FormLabel>
                    <Select
                      options={inactiveChaptersOptions}
                      isMulti={false}
                      onChange={(data) => {
                        setValue(
                          `chapters[${index + 2}][chapter_id]`,
                          data?.value
                        );
                      }}
                      styles={colourStyles}
                      placeholder="اختر حافظة الاسئلة (مصدر الأسئلة)"
                      defaultValue={
                        data?.chapters?.[index + 1]
                          ? {
                              label: data?.chapters?.[index + 1]?.name,
                              value: data?.chapters?.[index + 1]?.id,
                            }
                          : null
                      }
                    />
                  </Box>

                  <Box minW="200px" maxW="280px">
                    <LabelWithHint hint="عدد الأسئلة المسحوبة من هذه الحافظة">
                      عدد الأسئلة :
                    </LabelWithHint>
                    <Input
                      size="md"
                      defaultValue={
                        data?.chapters?.[index + 1]?.no_of_questions
                      }
                      error={errors?.question_number?.message}
                      onChange={(e) => {
                        setValue(
                          `chapters[${index + 2}][no_of_questions]`,
                          e.target.value
                        );
                      }}
                      placeholder="اكتب عدد الاسئلة"
                      name="question_number"
                      bg="#f5f5f5"
                      borderRadius="16px"
                    />
                  </Box>

                  <Box minW="220px">
                    <LabelWithHint hint="نوع الأسئلة المسحوبة من هذه الحافظة">
                      نوع الأسئلة :
                    </LabelWithHint>
                    <Stack direction="row" spacing="16px" flexWrap="wrap">
                      <label>
                        <input
                          {...register(`chapters[${index + 2}][type]`)}
                          type="radio"
                          value="0"
                          defaultChecked={
                            String(data?.chapters?.[index + 1]?.type ?? 0) ===
                            "0"
                          }
                        />
                        {" "}اختيار من متعدد
                      </label>
                      <label>
                        <input
                          {...register(`chapters[${index + 2}][type]`)}
                          type="radio"
                          value="1"
                          defaultChecked={
                            String(data?.chapters?.[index + 1]?.type) === "1"
                          }
                        />
                        {" "}مقالي
                      </label>
                    </Stack>
                  </Box>
                </HStack>
              );
            })}
          </VStack>

          <Button
            mt="16px"
            onClick={() => {
              setFieldsCount((s) => {
                setValue(`chapters[${s + 2}][type]`, "0");
                return s + 1;
              });
            }}
            isDisabled={
              totalSelectedQuestions >= watchTotalQustions ? true : false
            }
            bg="main_1"
            color="white"
            _hover={{ opacity: 0.9 }}
          >
            أضف حافظة أخرى
          </Button>
        </SettingCard>
      )}
    </VStack>
  );
};

export default StepTwo;
